import { render, staticRenderFns } from "./aprobaciones-conta.vue?vue&type=template&id=5bc0124a"
import script from "./aprobaciones-conta.vue?vue&type=script&lang=js"
export * from "./aprobaciones-conta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports